export const CSL_LISTINGS_PROMOTION = 'cslListingsPromotion';
export const PRICE_TABLE = 'priceTable';
export const IBW_CONVERSION = 'ibwConversion';
export const IBW_CONVERSION_WORDING_VARIANT = 'ibwConversionWordingVariant';
export const HOME_PAGE_REDESIGN = 'homePageRedesign';
export const HP_HERO_MAP = 'hpHeroMap';
export const HP_HERO_PHOTO = 'hpHeroPhoto';
export const HOME_PAGE_REDESIGN_PART_TWO = 'homePageRedesignPartTwo';
export const USE_HYDRATE = 'useHydrate';
export const USE_STICKY_BUTTON = 'useStickyButton';
export const USER_ONBOARDING = 'userOnboarding';
